// extracted by mini-css-extract-plugin
export default {"noAvailableResults":"NoAvailableResultsMaybe_noAvailableResults__P+KLl h4"};